// src/components/Dashboard/ChamadosPorMes.jsx
import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import Select from "../ui/Select";

const API_URL = process.env.REACT_APP_API_URL;

export default function ChamadosPorMes({ statusConfig }) {
  const [filtro, setFiltro] = useState("mes"); // padrão = mês
  const [dados, setDados] = useState([]);

  // 🔹 Opções de filtro
  const opcoes = [
    { value: "dia", label: "Dia a Dia" },
    { value: "semana", label: "Dia da Semana" },
    { value: "quinzena", label: "Quinzena" },
    { value: "mes", label: "Mês" },
    { value: "ano", label: "Ano" },
    { value: "geral", label: "Geral" },
  ];

  useEffect(() => {
    const fetchDados = async () => {
      try {
        const response = await fetch(
          `${API_URL}/Dashboard/chamados.php?filtro=${filtro}`
        );
        const data = await response.json();

        if (data.success && data.dados) {
          setDados(data.dados);
        } else {
          console.error("Resposta inesperada:", data);
          setDados([]);
        }
      } catch (error) {
        console.error("Erro ao buscar chamados finalizados:", error);
        setDados([]);
      }
    };

    fetchDados();
  }, [filtro]);

  return (
    <div className="p-6 bg-white rounded-sm shadow-lg shadow-black/30">
      {/* Cabeçalho com título e select */}
      <div className="flex items-center justify-between mb-4">
        <h3
          className="font-bold"
          style={{
            fontFamily: '"Source Sans Pro", sans-serif',
            fontSize: "14px",
            color: "#777777",
          }}
        >
          Total de Chamados Finalizados
        </h3>

        <div className="w-40">
          <Select options={opcoes} value={filtro} onChange={setFiltro} />
        </div>
      </div>

      {/* Gráfico */}
      <div className="h-[300px]">
        <ResponsiveContainer>
          <BarChart data={dados}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="periodo" stroke="#6b7280" />
            <YAxis stroke="#6b7280" />
            <Tooltip
              contentStyle={{
                backgroundColor: "#f9fafb",
                border: "1px solid #e5e7eb",
                borderRadius: "6px",
                color: "#111827",
                fontFamily: "Inter, sans-serif",
              }}
            />
            <Legend />

            <Bar
              dataKey="total"
              name="Finalizados"
              fill={statusConfig?.Finalizado?.color || "#22c55e"} // 🔹 Proteção + cor fallback
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
